// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-folder-wrapper {
    padding: 16px 32px;
    height: 90vh;
}

.patient-folder-wrapper .col-div {
    margin: 8px 0
}

.patient-folder-wrapper .detail-div {
    margin: 0 0 32px 32px;
}

.patient-folder-wrapper .main-heading-wrapper {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;

    background-color: #ecebeb;
    padding: 8px 16px;
}

.patient-folder-wrapper .main-heading {
    display: inline-flex;
    align-items: center;

    height: 32px;
}

.tag-multi-select {
    width: 480px;
    border: 1px solid #ecebeb;
    border-radius: 4px;

    padding: 8px;
    font-size: 14px;
}

.tag-multi-select option {
    padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/patient_folder.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;;IAE7B,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;;IAEnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;;IAElB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".patient-folder-wrapper {\n    padding: 16px 32px;\n    height: 90vh;\n}\n\n.patient-folder-wrapper .col-div {\n    margin: 8px 0\n}\n\n.patient-folder-wrapper .detail-div {\n    margin: 0 0 32px 32px;\n}\n\n.patient-folder-wrapper .main-heading-wrapper {\n    border-top: 1px solid #000;\n    border-bottom: 1px solid #000;\n\n    background-color: #ecebeb;\n    padding: 8px 16px;\n}\n\n.patient-folder-wrapper .main-heading {\n    display: inline-flex;\n    align-items: center;\n\n    height: 32px;\n}\n\n.tag-multi-select {\n    width: 480px;\n    border: 1px solid #ecebeb;\n    border-radius: 4px;\n\n    padding: 8px;\n    font-size: 14px;\n}\n\n.tag-multi-select option {\n    padding: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
